/*
 * @Author: hai.zhang
 * @LastEditors: hai.zhang
 */
import syIm from './sy-im.vue'
const Vue = window.Vue
const SyImConstructor = Vue.extend(syIm)
const im = {
  _im: null,
  create: function () {
    this._im = new SyImConstructor().$mount()
    document.body.appendChild(this._im.$el)
  },
  show: function (obj) {
    if (!this._im) {
      this.create()
    }
    if (this._im && this._im.isShow) {
      this._im.hide()
    }
    // setTimeout(() => {
    this._im.show(obj)
    // }, 200)
  },
  hide: function () {
    if (!this._im) {
      this.create()
    }
    this._im.hide()
  }
}
function registrySyIm () {
  Vue.prototype.syIm = im
}
export default registrySyIm